/* Details panel */

.details {
    padding: 0.5em;
}

.details table {
    width: 100%;

    :is(th), td {
        text-align: left;
        vertical-align: top;
    }

    :is(th) {
        white-space: nowrap;
    }

    :is(td) {
        width: 100%;
        white-space: pre-line;
    }
}

.edit-button.edit-button { /* XXX: competes for specificity with pure-button's font size, and Vite doesn't support listing library CSS files first */
    float: right;
    font-size: 70%;
}

/* Actions panel */

.actions {
    padding: 0.5em;
}

.sharePopup {
    margin: 0 0 0.5em;
    padding: 0.5em;
    border: 1px solid #eee;
    border-radius: 3px;
    background-color: #fcfcfc;
}

.sharePopup label {
    display: block;
    margin: 0 0 0.3em;
}

.closeButton {
    float: right;
    background-color: transparent;
    font-size: 75%;
}

.shareLink {
    display: flex;
}

.shareLink > input {
    flex: auto;
}

.shareLink > button {
    flex: none;
}

/* Map */

.map {
    padding: 0.5em;
    height: 600px;
}
